import { EffectCallback, useEffect } from 'react';

export const useDidMount = (cb: EffectCallback) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(cb, []);
};
